import {
  FETCH_LOG_OUT_DETAIL_REQUEST,
  FETCH_LOG_OUT_DETAIL_SUCCESS,
  FETCH_LOG_OUT_DETAIL_FAILURE,
} from '../../types/user';
import { getApi } from '../api';
import { apiEndPoint } from '../../../modules/data';

export const fetchLogOutDetailRequest = () => ({
  type: FETCH_LOG_OUT_DETAIL_REQUEST,
});

export const fetchLogOutDetailSuccess = (data) => ({
  type: FETCH_LOG_OUT_DETAIL_SUCCESS,
  data,
});

export const fetchLogOutDetailFailure = (error) => ({
  type: FETCH_LOG_OUT_DETAIL_FAILURE,
  error,
});

export const fetchLogOutDetail = (apiData) => (dispatch) => {
  dispatch(fetchLogOutDetailRequest());

  return getApi(apiEndPoint?.user?.logOutDetail, apiData)
    .then((data) => dispatch(fetchLogOutDetailSuccess(data)))
    .catch((error) => dispatch(fetchLogOutDetailFailure(error)));
};
